var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-input-base-select',{attrs:{"options":_vm.options,"value":_vm.value,"is-list":"","icon":"document"},on:{"change":_vm.changeHandler,"focus":_vm.focusHandler,"blur":_vm.blurHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }